
define(
	'Code25.CaterpartsGlobal.Facets'
	, [
		"Utils", "FacetsItemsCollectionView", "Facets.FacetedNavigation.View","Tools"
	]
	, function (
		Utils, FacetsItemsCollectionView, FacetsFacetedNavigationView,Tools
	) {
		'use strict';
		return {
			mount: function mount(container) {

				function addMatch(match) {
					if (sessionStorage) {
						var matched = {};
						try {
							matched = JSON.parse(sessionStorage.getItem("matched") || "{}");
						} catch (err) { }
						matched[match] = true;
						sessionStorage.setItem("matched", JSON.stringify(matched));
					} else {
						window.matched = window.matched || {};
						window.matched[match] = true;
					}
				}


				function matchArrays(A, B) {
					for (var i = 0; i < A.length; i++) {
						for (var j = 0; j < B.length; j++) {
							if (A[i] == B[j]) {
								return A[i];
							}
						}
					}
				}




				function isOEM(word) {

					if (word) {
						var char, foundA = 0, foundB = 0, foundC = 0, numbers = 0;
						for (var i = 0; i < word.length; i++) {
							char = word.charAt(i);
							if (char >= '0' && char <= '9') {
								foundA = 1;
								numbers++;
								if (numbers >= 5) {
									foundC = 1;
								}
								if (foundA + foundB + foundC >= 2) { return true; }
							} else if (char.toUpperCase() != char.toLowerCase()) {
								foundB = 1;
								if (foundA + foundB + foundC >= 2) { return true; }
							} else if (char == "." || char == "-") {
								foundC = 1;
								if (foundA + foundB + foundC >= 2) { return true; }
							}
						}
					}
				}

				function hasOEM(words) {
					if (words) {
						words = words.split(" ");
						for (var i = 0; i < words.length; i++) {
							if (isOEM(words[i])) {
								return true;
							}
						}
					}
					return false;
				}

				var FacetsItemCellView = require("Facets.ItemCell.View");
				if (FacetsItemCellView) {
					if (FacetsItemCellView.FacetsItemCellView) {
						FacetsItemCellView = FacetsItemCellView.FacetsItemCellView;
					}
					_.extend(FacetsItemCellView.prototype, {


						getContext: _.wrap(FacetsItemCellView.prototype.getContext, function (getContext) {


							var res = getContext.apply(this, _.rest(arguments));

							var searchkeywords = res.model.get("searchkeywords");
							if (searchkeywords) {
								var search = searchkeywords.toLowerCase().split(" ");
								var url_options = Utils.parseUrlOptions(window.location.href);
								var keywords = url_options.keywords;
								if (isOEM(keywords)) {
									keywords = keywords.toLowerCase();
									var newMatch = matchArrays(keywords.split(" "), search);
									if (newMatch) {
										res.match = newMatch.toUpperCase();
										addMatch(newMatch);
									}

								}

							}

							return res;

						})
					});
				}



				var ItemsSearcherItemView = require("ItemsSearcher.Item.View");
				if (ItemsSearcherItemView) {
					if (ItemsSearcherItemView.ItemsSearcherItemView) {
						ItemsSearcherItemView = ItemsSearcherItemView.ItemsSearcherItemView;
					}
					_.extend(ItemsSearcherItemView.prototype, {


						getContext: _.wrap(ItemsSearcherItemView.prototype.getContext, function (getContext) {


							var res = getContext.apply(this, _.rest(arguments));
							if (res.model) {
								var searchkeywords = res.model.get("searchkeywords");
								if (searchkeywords) {
									var search = searchkeywords.toLowerCase().split(" ");

									var keywords = res.currentQuery;
									if (isOEM(keywords)) {
										keywords = keywords.toLowerCase();
										var newMatch = matchArrays(keywords.split(" "), search);
										if (newMatch) {
											res.match = newMatch.toUpperCase();
											addMatch(newMatch);
										}
									}

								}
							}
							return res;

						})
					});
				}

				//min sort models

				function miniSort(models, keywords) {

					if (models.length > 0) {
						var searchkeywords, priority = [], search, lkeywords, score, oem, itemid, storedisplayname2;
						lkeywords = keywords.toLowerCase();
						oem = isOEM(lkeywords);
						var newMatch;
						for (var i = 0; i < models.length; i++) {
							score = 0;
							//match oem

							searchkeywords = models[i].get("searchkeywords") || (models[i].get("item") && models[i].get("item").get("searchkeywords"));
							search = searchkeywords ? searchkeywords.toLowerCase().split(" ") : [];

							if (oem) {

								newMatch = matchArrays(lkeywords.split(" "), search);
								if (newMatch) {
									score += 2;
								}
							}
							//match name
							storedisplayname2 = models[i].get("storedisplayname2") || models[i].get("item").get("storedisplayname2");
							search = storedisplayname2 ? storedisplayname2.toLowerCase().split(" ") : [];

							newMatch = matchArrays(lkeywords.split(" "), search);
							if (newMatch) {
								score += 1;
							}


							//match part
							itemid = models[i].get("itemid") || models[i].get("item").get("itemid");

							newMatch = matchArrays(lkeywords.split(" "), [itemid && itemid.toLowerCase()]);
							if (newMatch) {
								score += 2;
							}

							priority.push(score);
						}


						//sort by score
						var swap, change;
						do {
							change = false;
							for (var i = 0; i < priority.length - 1; i++) {
								if (priority[i] < priority[i + 1]) {
									swap = priority[i];
									priority[i] = priority[i + 1];
									priority[i + 1] = swap;

									swap = models[i];
									models[i] = models[i + 1];
									models[i + 1] = swap;
									change = true;
								}
							}
						} while (change);

					}
				}


				//extra sorting of items.
				var FacetsBrowseView = require("Facets.Browse.View");
				if (FacetsBrowseView) {
					FacetsBrowseView.prototype.childViews['Facets.Items'] = function () {
						if (FacetsItemsCollectionView.FacetsItemsCollectionView) {
							FacetsItemsCollectionView = FacetsItemsCollectionView.FacetsItemsCollectionView;
						}
						var keywords = this.translator.getOptionValue('keywords');
						var models = this.model.get('items').models;
						var original = this.translator.getUrl();
						//storedisplayname2
						if (original.indexOf("order=") == -1 && keywords) {

							miniSort(models, keywords);

						}

						while (models.length > this.translator.options.show) { //fake limit
							models.pop();
						}


						var self = this;
						var display_option = _.find(this.itemsDisplayOptions, function (option) {
							return option.id === self.translator.getOptionValue('display');
						});
						return new FacetsItemsCollectionView({
							application: this.application,
							keywords: keywords,
							collection: models,
							viewsPerRow: parseInt(display_option.columns, 10),
							cellViewTemplate: display_option.template
						});
					}

					FacetsBrowseView.prototype.childViews['Facets.FacetedNavigation'] = function (options) {
						var exclude = _.map((options.excludeFacets || '').split(','), function (
							facet_id_to_exclude
						) {
							return String(facet_id_to_exclude).trim();
						});
						var has_categories = !!(this.category && this.category.categories);
						var has_items = this.model.get('items').length;
						var has_facets =
							has_items && this.model.get('facets') && this.model.get('facets').length;
						var applied_facets = this.translator.cloneWithoutFacetId('category').facets;
						var has_applied_facets = applied_facets.length;

						var isVanStock = this.model.get("category") && this.model.get("category").id == "205";

						return new FacetsFacetedNavigationView({
							categoryItemId: this.category && this.category.itemid,
							clearAllFacetsLink: this.translator.cloneWithoutFacets().getUrl(),
							hasCategories: has_categories,
							hasItems: has_items,

							// facets box is removed if don't find items
							hasFacets: has_facets,

							hasCategoriesAndFacets: has_categories && has_facets,

							// Categories are not a real facet, so lets remove those
							appliedFacets: applied_facets,

							hasFacetsOrAppliedFacets: has_facets || has_applied_facets,

							// ,	translatorUrl: this.translator.getUrl()
							translator: this.translator,

							// ,	translatorConfig: this.options.translatorConfig
							facets: _.filter(this.model.get('facets'), function (facet) {
								if (isVanStock) {
									if (facet.id == "custitem_van_stock_filter") {
										return !_.contains(exclude, facet.id);
									} else {
										return false;
									}
								} else {
									if (facet.id != "custitem_van_stock_filter") {
										return !_.contains(exclude, facet.id);
									} else {
										return false;
									}
								}
							}),

							totalProducts: this.model.get('total'),
							keywords: this.translator.getOptionValue('keywords')
						});
					}

					FacetsBrowseView.prototype.render = function render() { //Hack to trigger the pusher for some reason.
						this._render();
						setTimeout(function () {
							this.$('[data-action="pushable"]').scPush();
						}, 100);
Tools.adjustSpacers();
					}



				}
				var FacetsFacetedNavigationItemCategoryView = require("Facets.FacetedNavigationItemCategory.View");
				if (FacetsFacetedNavigationItemCategoryView) {
					_.extend(FacetsFacetedNavigationItemCategoryView.prototype, {


						getContext: _.wrap(FacetsFacetedNavigationItemCategoryView.prototype.getContext, function (getContext) {


							var res = getContext.apply(this, _.rest(arguments));
							if (this.categoryUrl == "/Products/van-stock") {
								res.showFacet = false;
							}
							return res;

						})
					});
				}

				//extra sorting of type ahead
				var ItemsSearcherView = require("ItemsSearcher.View");
				if (ItemsSearcherView) {
					_.extend(ItemsSearcherView.prototype, {


						initialize: _.wrap(ItemsSearcherView.prototype.initialize, function (initialize) {


							var res = initialize.apply(this, _.rest(arguments));

							return res;
						}),
						loadSuggestionItemsSource: _.wrap(ItemsSearcherView.prototype.loadSuggestionItemsSource, function (loadSuggestionItemsSource, query, callback, callbackAsync) {

							var self = this;
							arguments[3] = function (labels) {
								miniSort(self.collection.models, self.options.query);

								if (self.initialLimit > 0) {
									while (self.collection.models.length > self.initialLimit) {
										self.collection.models.pop();
										self.collection.length--;
									}
								}

								self.collection = self.collection;

								if (typeof labels[0] == "string") {
									labels = [labels[0]];
								} else {
									labels = [];
								}
								for (var i = 0; i < self.collection.length; i++) {
									labels.push(self.collection.models[i].get("internalid"));
								}
								callbackAsync(labels);
							}

							var res = loadSuggestionItemsSource.apply(this, _.rest(arguments));




							return res;

						}), getCurrentQuery: function getCurrentQuery() {
							var q = String(this.$searchElement.val()).trim();
							var oem = hasOEM(q);
							if (this.options.sort == "custitem_c25_last2yearssales:desc" && oem) {
								this.options.sort = "relevance:desc";
							}
							if (this.options.sort == "relevance:desc" && !oem) {
								this.options.sort = "custitem_c25_last2yearssales:desc";
							}
							return q;
						}
					});
				}

				//extra fields for page one of search, to help mini search.
				var FacetsTranslator = require("Facets.Translator");
				if (FacetsTranslator) {

					FacetsTranslator.prototype.getApiParams = function getApiParams() {
						var params = {};

						_.each(this.facets, function (facet) {
							switch (facet.config.behavior) {
								case 'range':
									var value =
										typeof facet.value === 'object'
											? facet.value
											: { from: 0, to: facet.value };
									params[facet.id + '.from'] = value.from;
									params[facet.id + '.to'] = value.to;
									break;
								case 'multi':
									params[facet.id] = facet.value.sort().join(','); // this coma is part of the api call so it should not be removed
									break;
								default:
									params[facet.id] = facet.value;
							}
						});

						params.sort = this.options.order;
						params.limit = this.options.show;
						// if (this.options.page == 1) {
						//params.limit = 48;
						// }
						params.offset = this.options.show * this.options.page - this.options.show;

						params.q = this.options.keywords;

						if (params.q) { //force relevance for searches.
							if (params.sort == "custitem_c25_last2yearssales:desc") {
								if (hasOEM(params.q)) {
									params.sort = "relevance:desc";
								}
							}
						}

						if (this.isCategoryPage) {
							params.commercecategoryurl = this.categoryUrl;
							params.sort = params.sort.replace('relevance', 'commercecategory');
						}
						// else{
						// 	//this.sortOptions[0].id = "relevance:desc";
						// 	if(params.sort=="custitem_c25_last2yearssales:desc"){
							
						// 	params.sort = 'relevance:desc';
						// 	}
						// }

						return params;
					}

				}


				//sort facets
				var FacetsFacetedNavigationItemView = require("Facets.FacetedNavigationItem.View");
				if (FacetsFacetedNavigationItemView) {
					if (FacetsFacetedNavigationItemView.FacetsFacetedNavigationItemView) {
						FacetsFacetedNavigationItemView = FacetsFacetedNavigationItemView.FacetsFacetedNavigationItemView;
					}
					_.extend(FacetsFacetedNavigationItemView.prototype, {


						getContext: _.wrap(FacetsFacetedNavigationItemView.prototype.getContext, function (getContext) {


							var res = getContext.apply(this, _.rest(arguments));

							if (res.extraValues.length > 0) {
								var len = res.displayValues.length;
								var values = [];
								for (var i = 0; i < res.displayValues.length; i++) {
									values.push(res.displayValues[i]);
								}
								for (var i = 0; i < res.extraValues.length; i++) {
									values.push(res.extraValues[i]);
								}
								values.sort(function (A, B) {
									return A.label && A.label.localeCompare(B.label);
								});

								res.displayValues = [];
								res.extraValues = [];

								for (var i = 0; i < len; i++) {
									res.displayValues.push(values[i]);
								}
								for (var i = len; i < values.length; i++) {
									res.extraValues.push(values[i]);
								}

							} else {
								res.displayValues.sort(function (A, B) {
									return A.label && A.label.localeCompare(B.label);
								});
							}
							return res;

						})
					});
				}

				var CartQuickAddToCartView = require("Cart.QuickAddToCart.View");
				if (CartQuickAddToCartView) {


					var ProductDetailsQuantityView = require('ProductDetails.Quantity.View');

					CartQuickAddToCartView.prototype.childViews.Quantity = function () {

						return new ProductDetailsQuantityView({
							model: this.model
						});
					}

					ProductDetailsQuantityView.prototype.setQuantity = function (e) {

						e.preventDefault();

						var value = parseInt(this.$(e.currentTarget).data('value'), 10);
						
						var $input_quantity = this.$('[name="quantity"]');
						var old_value = parseInt($input_quantity.val(), 10);
						var new_quantity = old_value + value;

						$input_quantity.val(new_quantity).trigger('blur');
						if ($input_quantity.closest(".facets-item-cell-list-box").length == 1) {
							this.model.set("quantity", new_quantity);

							var $remove = this.$('.product-details-quantity-remove');
							$remove.prop("disabled", new_quantity<=1);

						}
					}

					ProductDetailsQuantityView.prototype.disableFocus= function(e) {
						var $input_quantity = this.$('[name="quantity"]');
						var new_quantity = parseInt($input_quantity.val(), 10);
						if ($input_quantity.closest(".facets-item-cell-list-box").length == 1) {
							this.model.set("quantity", new_quantity);

							var $remove = this.$('.product-details-quantity-remove');
							$remove.prop("disabled", new_quantity<=1);
						}
						if (e.keyCode === 13) {
							this.$('[name="quantity"]').blur();
						}
					}

				}



			}

		}

	});
